import { Col } from "@commonlibs";
import styled, { css } from "styled-components";

export const CameraQRReaderDisplayRoot = styled(Col)(
    ({ theme }) => css`
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 2;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: ${theme.spacing.all(12.5, 10)};
        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    `,
);
